import { AppState } from '../models/state/appState';

/**
 * Selects the orange provisioning zones.
 * @param state The application state.
 */
export function selectMvnoTemplates(state: AppState) {
  return state.mvnoTemplates;
}
